import React from "react";
import { Button, MenuSection } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { PublisherPrefixStatusEnum } from "../../types/Api";
export var buildPublisherPrefixActionMenu = function (publisherPrefix, canEditPublisherPrefix, onEdit, extraActions) {
    if (extraActions === void 0) { extraActions = []; }
    var canEdit = canEditPublisherPrefix &&
        publisherPrefix.status === PublisherPrefixStatusEnum.ACTIVE;
    if (!canEdit && extraActions.length === 0) {
        return undefined;
    }
    return function (_a) {
        var _b = _a === void 0 ? {} : _a, onToggle = _b.onToggle;
        return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
            canEdit && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: onEdit, fullWidth: true },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.edit" }))),
            extraActions.map(function (renderAction, index) { return (React.createElement(React.Fragment, { key: index }, renderAction(onToggle))); })));
    };
};
